import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const BlogListContainer = styled.ul`
    max-width: 100vw;
    padding: 1rem;
    list-style: none;
    ${device.md} {
        max-width: 60vw;
        padding: 1rem;
    }
`;

export const ListItem = styled.li`
    padding-top: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid ${colourScheme.white};

    &:last-child {
        border-bottom: none;
    }
`;

export const Article = styled.article`
    margin-bottom: 2rem;
    list-style: none;
`;

export const Time = styled.time`
    display: block;
    margin-bottom: 0.5rem;
    color: ${colourScheme.grey};
`;

export const DescriptionContainer = styled.div`
    color: ${colourScheme.white};
`;

export const TagsContainer = styled.ul`
    margin-top: 1.5rem;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`;
